import styled from "styled-components/macro";

export const RadioLabelComponentWrapper = styled.div`
  display: flex;
  align-items: ${({ labelDescription }) =>
    labelDescription ? "flex-start" : "center"};
  gap: 4px;
  cursor: pointer;

  .radio-btn {
    padding: 4px;
    height: 20px;
  }

  .label-data {
    display: flex;
    flex-direction: column;

    h4 {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.14px;
    }

    p {
      color: var(--Neutral-80);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.12px;
    }
  }
`;
